<template>
  <grid-container class="text-center">
    <p>Congratulations on completing your appraisal form!</p>

    <p>You will be notified once the procedure is completed!</p>

    <p>Thank you and we hope you enjoyed the experience!</p>
    <div class="feedback-wrapper">
      <el-form ref="form" size="normal" v-if="!isEvaluator || isEvaluatorButCandidate">
        <el-form-item label="">
          <template slot="label">
            <div style="text-align: left;">
              Comments and Feedback
            </div>
          </template>
          <el-input type="textarea" :rows="5" v-model="textarea">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="sendFeedback" :disabled="textarea == null || textarea == ''">Submit Feedback</el-button>
          <el-button type="secondary" @click="returnToDashboard">Return To Dashboard</el-button>
        </el-form-item>
      </el-form>
      <div v-else>
        <el-button type="secondary" @click="returnToDashboard">Return To Dashboard</el-button>
      </div>
    </div>
    <!-- <el-button @click="viewResults" type="primary">
      View Results
    </el-button> -->
  </grid-container>
</template>

<script>
export default {
  name: 'Completed',
  data() {
    return {
      textarea: ''
    }
  },
  computed: {
    siteUrl() {
      return process.env.VUE_APP_DASHBOARD_APPRAISAL_SCREEN
    },
    evalSiteUrl() {
      return process.env.VUE_APP_DASHBOARD_APPRAISAL_SCREEN_EVAL
    },
    assessment() {
      return this.$store.getters.assessment
    },
    isEvaluator() {
      return this.$store.getters.isEvaluator
    },
    isEvaluatorButCandidate() {
      return this.$store.getters.isEvaluatorButCandidate
    }
  },
  created() {
    if (this.assessment.feedback) {
      this.textarea = this.assessment.feedback
    }
  },
  methods: {
    returnToDashboard() {
      if (this.isEvaluator) {
        window.location = this.evalSiteUrl
      } else {
        window.location = this.siteUrl
      }
      
    },
    async sendFeedback() {
      const data = {
        assessmentId: this.assessment.id,
        feedback: this.textarea
      }
      await this.$store.dispatch('sendFeedback', data)
      this.$notify({
        title: "Success",
        message: "Feedback has been sent!",
        type: 'success'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .container p {
    margin: 24px 0;
  }
  .feedback-wrapper {
    max-width: 600px;
    margin: 0 auto;
    .el-form-item__label {
      text-align: left;
    }
  }
</style>
